import * as React from 'react';
import { Select } from 'antd';
import PickListContext from 'src/context/pickListContext';
import { ModeOption } from 'antd/lib/select';

interface IProps {
	// passed props
	value?: number[] | number;
	onChange: (e: any) => void;
	onSearch?: (e: any, options: any) => void;
	labelText?: string;
	id?: string;
	name?: string;
	className?: string;
	required?: boolean;
	pickListCode: string;
	placeholder: string;
	mode?: ModeOption;
	parentCode?: string;
	dropdownStyle?: string;
	specifiedOptions?: PickListItemResponseDTO[];
	disabled?: boolean;
	sort?: boolean;
}

class DropdownInputAnt extends React.Component<IProps> {
	public static contextType = PickListContext;
	constructor(props: IProps) {
		super(props);
	}

	public render() {
		const defaultValue = this.setDefaultValue();
		const selectValue = this.setSelectValue();
		const options = this.setOptions(this.props.parentCode!);
		// Antd uses react component under the hood, we want to open on focus so users can tab through
		// https://github.com/react-component/select
		const rcProps = {
			// showAction: ['focus', 'click']
		};
		return (
			<Select
				{...rcProps}
				defaultValue={defaultValue}
				value={selectValue}
				mode={this.props.mode!}
				onChange={this.props.onChange}
				placeholder={this.props.placeholder}
				optionFilterProp="children"
				filterOption={this.getFilterOption}
				labelInValue={true}
				showArrow={true}
				showSearch={true}
				// onSearch={(e: any) => this.props.onSearch!(e, options.search)}
				className={this.props.className}
				disabled={this.props.disabled}
			>
				{options.options}
			</Select>
		);
	}

	private getFilterOption(inputValue: string, option: any) {
		let filterOption: boolean = false;

		if (Array.isArray(option.props.children)) {
			filterOption = option.props.children.find((child: string) => child.toLowerCase().includes(inputValue.toLowerCase()));
		}
		else {
			filterOption = option.props.children.toLowerCase().includes(inputValue.toLowerCase());
		}

		return filterOption;
	}

	private sortPickListItems = (a: PickListItemResponseDTO, b: PickListItemResponseDTO) => {
		return a.sort! < b.sort! ? -1 : 1;
	}

	private setOptions = (code: string) => {
		// Be careful that specifiedOptions is ONLY used for dataset licensed products for now, it may not be complitable with other scenarios.
		if (this.props.specifiedOptions) {
			const selectableOptions = this.props.specifiedOptions.filter(o => o.isActive).map((item: PickListItemResponseDTO) => {
				return <Select.Option key={item.id!.toString()} value={item.id}> {item.description!} </Select.Option>;
			});

			const searchOptions = this.props.specifiedOptions.filter(o => o.isActive).map((item: PickListItemResponseDTO) => {
				return ({ key: item.id!.toString(), value: item.description! });
			});

			return ({ options: selectableOptions, search: searchOptions });
		}

		let contextItems: PickListItemResponseDTO[] = [];
		contextItems = (this.props.sort ? this.context.pickListItems.sort(this.sortPickListItems) : this.context.pickListItems)
			.filter((p: PickListItemResponseDTO) => p.isActive);

		if (code !== undefined || code !== '') {
			const parentItem = contextItems.find((item: PickListItemResponseDTO) => item.code === code);
			if (parentItem) {
				const parentItems = contextItems
					.filter((item: PickListItemResponseDTO) => item.pickListTypeCode === this.props.pickListCode && item.parentId === parentItem.id!);

				const selectableOptions = parentItems.map(item => <Select.Option key={item.id!.toString()} value={item.id}>{item.description!}</Select.Option>);
				const searchOptions = parentItems.map(item => ({ key: item.id!.toString(), value: item.description! }));

				return ({ options: selectableOptions, search: searchOptions });
			}
		}

		const filteredItems = contextItems.filter((item: PickListItemResponseDTO) => item.pickListTypeCode === this.props.pickListCode);
		const selectOptions = filteredItems !== undefined && filteredItems.length > 0 ?
			filteredItems.map(item => <Select.Option key={item.id!.toString()} value={item.id}> {item.description!} </Select.Option>) : [];
		const searchableOptions = filteredItems !== undefined && filteredItems.length > 0 ?
			filteredItems.map(item => ({ key: item.id!.toString(), value: item.description! })) : [];
		return ({ options: selectOptions, search: searchableOptions });

	}

	private setSelectValue = () => {
		let select;
		if (Array.isArray(this.props.value)) {
			const valueArray = this.props.value as number[]; // TODO: Forgive me my sins
			select = valueArray ? this.context.pickListItems
				.filter((item: PickListItemResponseDTO) => item.pickListTypeCode === this.props.pickListCode && valueArray!.indexOf(item.id!) !== -1)
				.map((foundVal: PickListItemResponseDTO) => ({ key: foundVal.id!, label: foundVal.description! })) : [];
			return select;
		}

		else if (this.props.value === undefined) {
			// select = { key: '', label: '' };
			return select;
		}

		else if (this.context.pickListItems !== undefined && this.context.pickListItems.length > 0 && this.props.value !== undefined) {
			const picklistItem = this.context.pickListItems.find((item: PickListItemResponseDTO) => item.id === this.props.value)!;
			select = { key: this.props.value, label: picklistItem.description };
			return select;
		}

		return select;
	}

	private setDefaultValue = () => {
		let defaultValue: any[] = [];

		const defaultPicklistItems =
			this.context.pickListItems!.filter((x: PickListItemResponseDTO) => x.isDefault! && x.pickListTypeCode === this.props.pickListCode);
		if (defaultPicklistItems) {
			defaultValue = defaultPicklistItems.map((item: PickListItem) => ({ key: item.id!.toString(), label: '' }));
		}

		return defaultValue;
	}
}

export default DropdownInputAnt;